import _classCallCheck from "/builds/sezzle/website-cms-boilerplate/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/sezzle/website-cms-boilerplate/node_modules/@babel/runtime/helpers/esm/createClass.js";
import LANGUAGES_LIST from './data';

var ISO6391 = /*#__PURE__*/function () {
  function ISO6391() {
    _classCallCheck(this, ISO6391);
  }

  _createClass(ISO6391, null, [{
    key: "getLanguages",
    value: function getLanguages() {
      var codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return codes.map(function (code) {
        return {
          code: code,
          name: ISO6391.getName(code),
          nativeName: ISO6391.getNativeName(code)
        };
      });
    }
  }, {
    key: "getName",
    value: function getName(code) {
      return ISO6391.validate(code) ? LANGUAGES_LIST[code].name : '';
    }
  }, {
    key: "getAllNames",
    value: function getAllNames() {
      return Object.values(LANGUAGES_LIST).map(function (l) {
        return l.name;
      });
    }
  }, {
    key: "getNativeName",
    value: function getNativeName(code) {
      return ISO6391.validate(code) ? LANGUAGES_LIST[code].nativeName : '';
    }
  }, {
    key: "getAllNativeNames",
    value: function getAllNativeNames() {
      return Object.values(LANGUAGES_LIST).map(function (l) {
        return l.nativeName;
      });
    }
  }, {
    key: "getCode",
    value: function getCode(name) {
      var code = Object.keys(LANGUAGES_LIST).find(function (code) {
        var language = LANGUAGES_LIST[code];
        return language.name.toLowerCase() === name.toLowerCase() || language.nativeName.toLowerCase() === name.toLowerCase();
      });
      return code || '';
    }
  }, {
    key: "getAllCodes",
    value: function getAllCodes() {
      return Object.keys(LANGUAGES_LIST);
    }
  }, {
    key: "validate",
    value: function validate(code) {
      return LANGUAGES_LIST.hasOwnProperty(code);
    }
  }]);

  return ISO6391;
}();

export { ISO6391 as default };